import {reducers} from './reducer'

export default reducers;
